import CapTable from './cap-table';

export default CapTable;
